import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useGetUser from '../main/hooks/useGetUser';
import useGetMenu from '../main/hooks/useGetMenu';
import { resolvePageRedirectRoute } from '../main/constants/pageRedirect';
import JwtManager from '../main/utils/jwtManager';
import { hasMenuRouteAccess, normalizeRoutePath } from '../main/utils/routeAccess';

const PrivateRoute: FC<any> = (props: any) => {
  const { children, isPageLogin, routepath, skipMenuAccess } = props;
  const userisAuthenticated = useGetUser();
  const menuData = useGetMenu();
  const location = useLocation();
  const hasToken = Boolean(JwtManager.accessToken);
  const redirectPath = resolvePageRedirectRoute((userisAuthenticated as any)?.pageRedirect);
  const currentPath = normalizeRoutePath(location.pathname);
  const routeKey = routepath ?? currentPath.replace(/^\/+/, '');

  if (isPageLogin) {
    return children;
  }

  if (!hasToken) {
    if (userisAuthenticated && currentPath !== redirectPath) {
      return <Navigate to={redirectPath} replace />;
    }

    if (userisAuthenticated && redirectPath === '/home' && currentPath === '/home') {
      return children;
    }

    return <Navigate to="/login" replace />;
  }

  if (!userisAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (redirectPath === '/home' && currentPath !== '/home') {
    return <Navigate to="/home" replace />;
  }

  if (skipMenuAccess) {
    return children;
  }

  if (!menuData?.length) {
    return null;
  }

  if (!hasMenuRouteAccess(menuData, currentPath, routeKey)) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default PrivateRoute;
